import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { UiFeaturedModule } from '../ui-featured/ui-featured.module';
import { SagtoastModule } from './sagtoast/sagtoast.module';
// import { ChartsModule } from 'ng2-charts';
import { SagCheckboxGroupModule } from './sag-checkbox-group/sag-checkbox-group.module';
 
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UiFeaturedModule,
    PipesModule,
    DirectivesModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SagtoastModule,
    // ChartsModule,
    SagCheckboxGroupModule
  ],
  exports: [
    UiFeaturedModule,
    PipesModule,
    DirectivesModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SagtoastModule,
    // ChartsModule,
    SagCheckboxGroupModule
  ]
})
export class SharedModule { }
